package pl.finn.forms.enums

import pl.finn.forms.service.ValueConverter
import pl.finn.forms.utils.NumberConverter

enum class ControlType {
  ADDRESS(
    arrayOf<String?>(
      "http://crd.gov.pl/xml/schematy/adres/2009/11/09/",
      "http://crd.gov.pl/xml/schematy/adres/2009/03/06/"
    ), arrayOf<String?>("AdresTyp", "AdresTyp")
  ),
  ANNEX(
    arrayOf<String?>(
      "http://crd.gov.pl/xml/schematy/struktura/2009/11/16/", "http://crd.gov.pl/xml/schematy/struktura/2009/03/06/",
      "http://crd.gov.pl/xml/schematy/struktura/2008/05/09/"
    ), arrayOf<String?>("ZalacznikTyp", "ZalacznikTyp", "ZalacznikTyp")
  ),
  ANNEX_PWPW("----", "----"),
  ANY(
    null as String?, null as String?
  ),
  ANY_TYPE("##any", "##any"),
  BOOLEAN("http://www.w3.org/2001/XMLSchema", "boolean"),
  CZAS(
    arrayOf<String?>(
      "http://crd.gov.pl/xml/schematy/meta/2009/11/16/",
      "http://crd.gov.pl/xml/schematy/meta/2009/03/06/",
      "http://crd.gov.pl/xml/schematy/meta/2008/05/09/"
    ), arrayOf<String?>("Czas", "Czas", "Czas")
  ),
  DATE("http://www.w3.org/2001/XMLSchema", "date"),
  E_MAIL(
    arrayOf<String?>(
      "http://crd.gov.pl/xml/schematy/adres/2009/11/09/", "http://crd.gov.pl/xml/schematy/adres/2009/03/06/"
    ), arrayOf<String?>("EmailTyp", "EmailTyp")
  ),
  HTML(
    null as String?, null as String?
  ),
  NIP(
    arrayOf<String?>(
      "http://crd.gov.pl/xml/schematy/osoba/2009/11/16/",
      "http://crd.gov.pl/xml/schematy/osoba/2009/03/06/"
    ), arrayOf<String?>("NIPTyp", "NIPTyp")
  ),
  NUMBER(
    arrayOf<String?>(
      "http://www.w3.org/2001/XMLSchema", "http://www.w3.org/2001/XMLSchema",
      "http://www.w3.org/2001/XMLSchema"
    ), arrayOf<String?>("float", "double", "decimal"), NumberConverter()
  ),
  MSZKIIP(
    "http://crd.gov.pl/xml/schematy/meta/2009/11/16/", "Wartosc"
  ),
  ORSIP("http://crd.gov.pl/xml/schematy/meta/2009/11/16/", "Wartosc"),
  PESEL(
    arrayOf<String?>(
      "http://crd.gov.pl/xml/schematy/osoba/2009/11/16/", "http://crd.gov.pl/xml/schematy/osoba/2009/03/06/"
    ), arrayOf<String?>("PESELTyp", "PESELTyp")
  ),
  PKD_2007(
    "http://crd.gov.pl/xml/schematy/dziedzinowe/ms/krs/2009/11/16/", "KodPKDTyp"
  ),
  REGON(
    arrayOf<String?>(
      "http://crd.gov.pl/xml/schematy/instytucja/2009/03/06/",
      "http://crd.gov.pl/xml/schematy/instytucja/2009/11/16/"
    ), arrayOf<String?>("REGONTyp", "REGONTyp")
  ),
  YEAR("http://www.w3.org/2001/XMLSchema", "gYear"),
  A_CITY(
    "http://crd.gov.pl/xml/schematy/adres/2009/11/09/", "MiejscowoscTyp"
  ),
  A_STREET("http://crd.gov.pl/xml/schematy/adres/2009/11/09/", "UlicaTyp"),
  A_NUMBER(
    "http://crd.gov.pl/xml/schematy/adres/2009/11/09/", "BudynekTyp"
  );

  private val converter: ValueConverter
  private var names: Array<String?>
  private var namespaces: Array<String?>

  constructor(namespace: String?, name: String?) : this(arrayOf<String?>(namespace), arrayOf<String?>(name)) {}
  constructor(namespaces: Array<String?>, names: Array<String?>) {
    this.names = names
    this.namespaces = namespaces
    converter = NumberConverter()
  }

  constructor(namespaces: Array<String?>, names: Array<String?>, converter: ValueConverter) {
    this.names = names
    this.namespaces = namespaces
    this.converter = converter
  }

  fun convertToValue(value: String?): String? {
    return converter.convertToValue(value)
  }

  fun convertToView(value: String?): String? {
    return converter.convertToView(value)
  }

  fun matches(namespace: String, name: String): Boolean {
    for (i in namespaces.indices) {
      try {
        if ((namespace == namespaces[i]) && name == names[i]) {
          return true
        }
      } catch (e: NullPointerException) {
        println("MetaView.ControlType.matches() " + e.toString() + " " + e.message + " " + namespace + " " + name)
      } catch (e: IndexOutOfBoundsException) {
        println("MetaView.ControlType.matches() " + e.toString() + " " + e.message)
      }
    }
    return false
  }
}